export default __webpack_public_path__ + "static/media/Level34.b6f8c1c7.svg";